import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 1.5em;
`

const relationshipText = css`
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
`

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 0.5em;

  & > span:nth-of-type(2) {
    border: solid 1px ${({ theme }) => theme.primary};
    padding: 0.5em;
    border-radius: 4px;

    & > button {
      width: 100%;
      ${relationshipText}
    }

    & > div {
      margin-top: 10px;
      width: 100%;

      ul {
        box-shadow: ${({ theme }) => theme.shadowSmallDarker};

        li {
          & button {
            ${relationshipText}
          }

          &:hover,
          &:focus {
            background: ${({ theme }) => theme.bgLight};
          }
        }
      }
    }
  }
`
